/*
==============================================================================
MANTRAROMA CUSTOM
Version: 1.0.0
Datum: 15.09.2026
Zweck: Positioniert den KI-Hinweis auf dem aktiven vergrößerten Produktbild.
==============================================================================
*/

(() => {
  const positionLabel = (viewer) => {
    const image = viewer.querySelector('.gallery-viewer__zoom-image');
    const label = viewer.querySelector(
      '.mantraroma-ai-image-label--zoom'
    );

    if (!image || !label) return;

    const imageRect = image.getBoundingClientRect();
    const labelRect = label.getBoundingClientRect();
    const spacing = 12;

    label.style.left = `${Math.max(
      spacing,
      imageRect.right - labelRect.width - spacing
    )}px`;

    const thumbnails = viewer.querySelector(
  '.gallery-viewer__thumbs'
);

const thumbnailsRect = thumbnails?.getBoundingClientRect();

label.style.top = `${Math.max(
  imageRect.top + spacing,
  (thumbnailsRect?.top || imageRect.bottom) -
    labelRect.height -
    10
)}px`;

    label.dataset.positioned = 'true';
  };

  const updateOpenViewer = () => {
    const viewer = document.querySelector(
      '.gallery-viewer-modal gallery-viewer'
    );

    if (viewer) {
      requestAnimationFrame(() => positionLabel(viewer));
    }
  };

  document.addEventListener(
    'load',
    (event) => {
      if (event.target.matches?.('.gallery-viewer__zoom-image')) {
        updateOpenViewer();
      }
    },
    true
  );

  document.addEventListener('click', () => {
    requestAnimationFrame(updateOpenViewer);
  });

  document.addEventListener('mousemove', updateOpenViewer);
  document.addEventListener('touchmove', updateOpenViewer, {
    passive: true
  });
  document.addEventListener('wheel', updateOpenViewer, {
    passive: true
  });

  window.addEventListener('resize', updateOpenViewer);
})();